import { render, staticRenderFns } from "./ParcourscliniqueCreate.vue?vue&type=template&id=642d5c4d&"
import script from "./ParcourscliniqueCreate.vue?vue&type=script&lang=js&"
export * from "./ParcourscliniqueCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports